// extracted by mini-css-extract-plugin
module.exports = {"outer":"_16iSn","heading":"kpsyR","subHeading":"_856aS","graphImage":"_38kmE","graphImageWrapper":"_2SS_t"};